var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    fill: "#F2F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1665 119.75C62.7082 116.947 68.5665 111.341 79.6665 111.341C90.7665 111.341 96.6248 104.614 98.1665 101.25M79.6665 79.6667V70.4167C79.6665 67.0109 82.4274 64.25 85.8332 64.25H116.667C120.072 64.25 122.833 67.0109 122.833 70.4167V95.0833C122.833 98.4891 120.072 101.25 116.667 101.25H106.614M91.9998 76.5833H110.5M85.8332 95.0833C85.8332 98.4891 83.0723 101.25 79.6665 101.25C76.2607 101.25 73.4998 98.4891 73.4998 95.0833C73.4998 91.6776 76.2607 88.9167 79.6665 88.9167C83.0723 88.9167 85.8332 91.6776 85.8332 95.0833Z",
    stroke: "#EF437B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 88.9166H110.5",
    stroke: "#EF437B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.a7b748957e4a18ae705810ea7efe9070.svg";
export { ForwardRef as ReactComponent };